export default __webpack_public_path__ + "static/media/set_sq.6b10db38.png";